import React, { createContext, useState, useContext  } from 'react';
import { APIContext } from '../../../../context/';
import {  Button } from '@material-ui/core';
import { DateTime } from "luxon";

export const ContactoContext = createContext();

const ContactoProvider = (props) => {

    const [open, setOpen] = useState(false);
 
    const [editableObject, seteditableObject] = useState({});
    const [dialogOpen, setDialogOpen] = useState(false);
    const { contactos,
        unCheck,deleteContact,
    } = useContext(APIContext);

    const idName = "id";

    const data = contactos

    const columns = [
        { name: 'id', label: '#' },
        { name: 'name', label: 'Nombre' },
        { name: 'phone', label: 'Teléfono' },
        { name: 'email', label: 'Correo electrónico' },
        {
          name: "date", label: "Fecha de envio",
          options: {
    
            filter: false,
            sort: false,
            empty: true,
            customBodyRenderLite: (dataIndex) => {
              const data = contactos[dataIndex].date;
    
              return (
                <>
                {DateTime.fromISO(data).setLocale('Sp').toFormat("dd'/'LL'/'yyyy HH:mm")}
                </>
              );
            }
          }
        }
    ];
     
    const options = {
        filter: true,
        filterType: "multiselect",
        textLabels: {
          body: {
            noMatch: "Sorry, no matching records found",
            toolTip: "Sort",
            columnHeaderTooltip: column => `Sort for ${column.label}`
          },
          pagination: {
            next: "Siguiente",
            previous: "Anterior",
            rowsPerPage: "Registros por página:",
            displayRows: "de",
          },
          toolbar: {
            search: "Buscar",
            downloadCsv: "Descargar CSV",
            print: "Imprimir",
            viewColumns: "ver Columnas",
            filterTable: "Filtrar Tabla",
          },
          filter: {
            all: "TODOS",
            title: "FILTROS",
            reset: "RESTABLECER",
          },
          viewColumns: {
            title: "Mostrar Columnas",
            titleAria: "Mostrar/Ocultar Columnas",
          },
          selectedRows: {
            text: "Registro(s) seleccionados",
            delete: "Eliminar",
            deleteAria: "Eliminar Registro(s) seleccionados",
          },
        },
        onRowsDelete:(rowsDeleted) => {
            const array = rowsDeleted.data
            const DeleteId = array.map((arr,index)=>{
                return contactos[arr.dataIndex].id
            })

            array.map((arr,index)=>{
                let id     = contactos[arr.dataIndex].id
                let nombre = contactos[arr.dataIndex].name
               
                deleteContact(id, nombre, DeleteId); 
                return arr
            })
            unCheck();
            return false
        },
        
    }

    const handleDialogOpen = () => {
        setDialogOpen(true);
      };
      const handleDialogClose = () => {
        setDialogOpen(false)
      }

    return (
        <ContactoContext.Provider
            value={{
            
                open,
                idName,
                columns,
                options,
                data,
                dialogOpen,
                editableObject,
       
                setOpen,
                handleDialogOpen,
                handleDialogClose,
            }}
        >
            {props.children}
        </ContactoContext.Provider>
    );
}

export default ContactoProvider;